/**
 * Rota legada /financeiro/lancamentos/criar — agora o "Novo lançamento" é um
 * slide-over dentro da Lista (mockup Fase 5 V2.2). Redireciona preservando o
 * deep link: ?novo abre o painel automaticamente.
 */
import React from "react";
import { Navigate } from "react-router-dom";

export default function LancamentoCriar() {
  return <Navigate to="/financeiro/lancamentos?novo=1" replace />;
}
